import * as React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from "gatsby-plugin-image"

export default class Layout extends React.Component { // } ({ pageTitle, children }) => {

  constructor(props) {
    super(props);
    this.state = {
      downloadMenuOpen: false
    };
  }

  componentDidMount() {
    const location = window.location;
    const params = new URLSearchParams(location.search);
    const shouldInitiateDownload = params.get("dl");

    if (shouldInitiateDownload === "1") {
      this.tryDownload(false)
    }
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    /*if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }*/

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
  }

  tryDownload(openMenuOnFailure = true) {
    console.log("Attempting download")
    let os = this.getMobileOperatingSystem();
    /*if (os === "Android") {
        window.location.href = "https://play.google.com/store/apps/details?id=com.samaitch.kntd"; 
    } else */
    if (os === "iOS") {
        window.location.href = "https://itunes.apple.com/app/id1572271760";
    } else if (openMenuOnFailure === true) {
      this.setState({ downloadMenuOpen: !this.state.downloadMenuOpen })
    }
  }

  render() {
    return (
      <div className="h-screen flex flex-col">
        <header>
          <title>kntd:discover | { this.props.pageTitle }</title>
          <nav class="bg-white sticky top-0 z-50">
            <div class="lg:container flex flex-wrap justify-between items-center mx-auto text-white py-2.5 px-6 md:px-12">
              <Link to="/" class="flex items-center">
                <div className="mr-3 rounded-xl overflow-hidden relative z-[1]">
                  <StaticImage 
                      className="w-[60px]"
                      src="../images/app_icon.png" 
                      alt="kntd:discover logo"/>
                </div>
              </Link>
              {/*<Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className="inline-flex justify-center text-white bg-primary hover:bg-secondary hover:text-white font-regular rounded-lg text-md px-5 py-2 text-center">
                    Download
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        <a href="https://itunes.apple.com/app/id1572271760" className="text-gray-700 hover:bg-gray-100 hover:text-gray-900 block px-4 py-2 text-sm">iPhone & iPad</a>
                      </Menu.Item>
                      <Menu.Item>
                        <a href="https://play.google.com/store/apps/details?id=com.samaitch.kntd" className="text-gray-700 hover:bg-gray-100 hover:text-gray-900 block px-4 py-2 text-sm">Android</a>
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>*/}
              <div class="relative inline-block text-left">
                <a href="https://apps.apple.com/us/app/kntd-discover-ravelry-app/id1572271760" target="_blank">
                  <StaticImage 
                    className="w-[160px]"
                    src="../images/ios_appstore_badge.png" 
                    alt="An iPhone running the kntd:discover app" />
                </a>
                {/*<div>
                  <button type="button" onClick={() => this.tryDownload()} className="text-white bg-primary hover:bg-secondary hover:text-white font-regular rounded-lg text-md px-5 py-2 text-center">Download</button>
                </div>*/}
                {/*<div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" id="download-menu" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">*/}
                <div className={this.state.downloadMenuOpen ? 'origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none' : 'hidden'}>
                  <div class="py-1" role="none">
                    <a href="https://itunes.apple.com/app/id1572271760" target="_BLANK" class="text-gray-700 hover:bg-gray-100 hover:text-gray-900 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-0">iPhone & iPad</a>
                    {/*<a href="https://play.google.com/store/apps/details?id=com.samaitch.kntd" target="_BLANK" class="text-gray-700 hover:bg-gray-100 hover:text-gray-900 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-1">Android</a>*/}
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </header>
        <main className="grow bg-primary">
          {this.props.children}
        </main>
        <footer className="bg-primary text-center text-white">
          <div className="text-center text-white text-xs pt-4 flex justify-center gap-2">
            <Link to="/privacy/">
              Privacy Policy
            </Link>
            <span>&#183;</span>
            <Link to="/terms/">
              Terms of Use
            </Link>
          </div>
          <div className="text-center text-white text-xs pt-2 pb-4">
            © 2022 Samuel Harrison &#183; <a href="https://samaitch.com">samaitch.com</a>
          </div>
        </footer>
      </div>
    )
  }
}